define(['angular', 'moment'], function(angular, moment) {


    function ElectronicSignatureService(
        orderService,
        tillPackService,
        bdcTabacPresseService,
        pricesService,
        $log,
        filesService,
        $http
    ) {
        var self = this;

        /**
         * @param  {Object} order
         * @param {boolean} vad
         * @param {boolean} joinRac
         * @param {String} documents
         * @param orderForm
         * @param user
         * @param liz
         * @return {Promise}
         */
        self.signAnOrder = function(order, vad, joinRac, documents, orderForm, user, liz) {
            return buildRequestData(order, vad, documents, orderForm, user)
                .then(function(requestData) {
                    $log.debug('electronicSignatureData', requestData);
                    var dateSendElectronicSignature = moment().format('YYYY-MM-DD');
                    return orderService.electronicSignature(
                        order.id,
                        order.client.id,
                        requestData,
                        dateSendElectronicSignature,
                        joinRac,
                        liz
                    );
                })
                .then(function(result) {
                    return result;
                });
        };

        /**
         * @param  {Object} order
         * @param {boolean} vad
         * @param {String} documents
         * @param orderForm
         * @param user
         * @return {Promise}
         */
        function buildRequestData(order, vad, documents, orderForm, user) {
            return new Promise(function(resolve, reject) {
                const businessUnit = 'BIM0000001';
                const rds = user.parent ? user.parent.mail : null;
                // const advUser = "BIMU000102"; // Code de l'ADV
                order.client.siren = order.client.SIRET ? order.client.SIRET.trim().substr(0, 9) : '';
                order.client.corporateName = order.client.corporateName ? order.client.corporateName.trim() : '';
                let reprise = order.client.siren === '';
                let isPurchase = order.contract.contractType.code === 'ACHAT';

                let requestData = {
                    externalReference: order.id,
                    externalLabel: `Devis ${order.client.firstName} ${order.client.lastName}`,
                    vad: vad,
                    isPurchase: isPurchase,
                    documents: buildDocumentsData(documents, isPurchase, order.id),
                    partnerADV: {
                        email: 'bimedia.commande@orisha.com',
                        firstName: 'Commande',
                        lastName: 'Orisha'
                    },
                    isA4Printer: !!order.options.find(o => o.optionType.code === 'IMPRIMANTE' && o.label !== 'Pas d\'imprimante Bimedia (Utilisation imprimante perso)'),
                };

                if(order.contract.contractType.code === 'ACHAT'){
                    requestData.signers = buildSignerData(order);
                }else{
                    requestData.siren = order.client.SIRET ? order.client.SIRET.trim().substr(0, 9) : '';
                    requestData.isRenewal = order.contract.scenarioType.code === 'RENOUVELLEMENT';
                    requestData.signer = buildSignerData(order);
                    requestData.entities = buildEntitiesData(order);
                    requestData.assets = buildOrderData(order, orderForm);
                    requestData.simulation = buildSimulationData(order);
                }

                resolve(requestData);
            });
        }

        /**
         * Construit la partie persons
         * @return {Object}
         */
        function buildEntitiesData(order) {
            const country = 'FR';

            return {
                main: {
                    siret: order.client.SIRET,
                    name: order.client.corporateName,
                    address1: order.client.addressStreet,
                    address2: null,
                    zipcode: order.client.addressPostalCode,
                    city: order.client.addressCity,
                    country: country,
                    iban: order.client.IBAN,
                    bic: order.client.codeBic,
                    email: order.client.email,
                    phone: order.client.mobilePhone,

                },
                invoicing: {
                    siret: order.client.SIRET,
                    name: order.client.corporateName,
                    address1: order.client.addressStreet,
                    address2: null,
                    zipcode: order.client.addressPostalCode,
                    city: order.client.addressCity,
                    country: country,
                    iban: order.client.IBAN,
                    bic: order.client.codeBic,
                    email: order.client.email,
                    phone: order.client.mobilePhone,
                    contactFirstName: order.client.firstName,
                    contactLastName: order.client.lastName,
                    contactEmail: order.client.email
                },
                delivery: {
                    siret: order.client.SIRET,
                    name: order.client.corporateName,
                    address1: order.client.addressStreet,
                    address2: null,
                    zipcode: order.client.addressPostalCode,
                    city: order.client.addressCity,
                    country: country,
                    iban: order.client.IBAN,
                    bic: order.client.codeBic,
                    email: order.client.email,
                    phone: order.client.mobilePhone,
                    contactFirstName: order.client.firstName,
                    contactLastName: order.client.lastName,
                    contactEmail: order.client.email
                }
            }
        }

        function buildSignerData(order){
            if(order.contract.contractType.code === 'ACHAT'){
                return [
                    {
                        firstName: order.client.firstName,
                        lastName: order.client.lastName,
                        email: order.client.email,
                        phone: order.client.mobilePhone,
                        role: 'client'
                    }
                ];
            }else {
                return {
                    firstName: order.client.firstName,
                    lastName: order.client.lastName,
                    email: order.client.email,
                    phone: order.client.mobilePhone,
                    position: 'Gérant'
                };
            }
        }

        /**
         * Construit la partie asset
         * @return {string}
         */
        function buildOrderData(order, orderForm) {
            const orderData = [];
            const dataType = 'MATERIAL';
            const manufacturer = 'BIMEDIA';
            let tills = tillPackService.getTillsByTillCode(orderForm, order);
            let degressiveRate = pricesService.getDegressiveRate(order, orderService.getNbTills(order.tills), true);
            let prices = pricesService.getDegressiveRateTillPrices(order.contract.contractType.code, degressiveRate);
            let mixedTillPrices = pricesService.getMixedTillPrice(
                tillPackService.getMixedPack(tills),
                order.contract.contractType.code
            );

            self.tills = tillPackService.getPricesByTillPack(order, prices, mixedTillPrices, tills);

            self.leaserOptions = bdcTabacPresseService.getFilteredLeaserOptions(order);

            // Ajout des packs caisses
            order.tills.forEach(function(till) {
                orderData.push({
                    externalReference: null,
                    manufacturer: manufacturer,
                    name: till.label,
                    description: 'Caisse enregistreuse de marques',
                    unitPrice: self.tills[till.tillType.code].price,
                    quantity: till.nbTills,
                    taxRate: '20',
                    idCategorie: null,
                    assetType: dataType,
                });
            });

            // Ajout des software
            let software = order.options.filter(
                option => option.optionType.code === 'LOGICIEL_CAISSE' || option.optionType.code === 'SERVICE_LOGICIEL'
            );
            if (software.length > 0) {
                orderData.push({
                    externalReference: null,
                    manufacturer: manufacturer,
                    name: software.map(soft => soft.description).join(' + '),
                    description: null,
                    unitPrice: order.prices.tillSoftware,
                    quantity: 1,
                    taxRate: '20',
                    idCategorie: null,
                    assetType: dataType
                });
            }

            // Ajout des options
            self.leaserOptions.forEach(function(option) {
                let optionPrice = pricesService.getOptionUnitPrice(option);
                orderData.push({
                    externalReference: null,
                    manufacturer: manufacturer,
                    name: option.label,
                    description: null,
                    unitPrice: optionPrice,
                    quantity: option.nbOptions,
                    taxRate: '20',
                    idCategorie: null,
                    assetType: dataType,
                });
            });

            return orderData;
        }

         /**
         * Construit la partie quotation
         * @param  {Object} order
         * @return {Object}
         */
        function buildSimulationData(order) {
            const SCENARIO_TYPES = {
                CONQUETE: 'CONQUETE',
                RENOUVELLEMENT: 'RENOUVELLEMENT'
            };

            const DEFAULT_CONTRACT_DATA = {
                frequency: 30, // mensuelle
                durationInMonths: 60,
                financedAmount: 0,
                rental: 0,
                firstPaymentValue: 0,
                firstPaymentValueType: 'AMOUNT',
                vrValue: 0,
                vrValueType: 'AMOUNT',
                total_age: 0,
                stages: []
            };

            const contratData = Object.assign({}, DEFAULT_CONTRACT_DATA);

             const contract = order.contract;

            // Configuration des périodes spéciales
            if (contract.nbMonthsCalage > 0) {
                contratData.gracePeriod = contract.nbMonthsCalage;
            }

            if (contract.nbMonthsFranchise > 0) {
                contratData.delay = contract.nbMonthsFranchise;
            }

            // Construction des stages selon la logique métier
             contratData.stages = buildContractStages(order, SCENARIO_TYPES);

            return contratData;
        }

        /**
         * Construit les stages du contrat selon les règles métier
         * @param {Object} order
         * @param {Object} SCENARIO_TYPES
         * @return {Array}
         */
        function buildContractStages(order, SCENARIO_TYPES) {
            const contract = order.contract;
            const stages = [];
            let stageIndex = 0;

            if (contract.nbMonthsCalage > 0) {
                const stage = createStageWithCalage(order, SCENARIO_TYPES, stageIndex);
                if (stage) {
                    stages.push(stage);
                }
            }
            else {
                const contractStages = createStagesWithoutCalage(order, stageIndex);
                stages.push(...contractStages);
            }

            return stages;
        }

        /**
         * Crée un stage avec période de calage
         * @param {Object} order
         * @param {Object} SCENARIO_TYPES
         * @param {number} index
         * @return {Object|null}
         */
        function createStageWithCalage(order, SCENARIO_TYPES, index) {
            const contract = order.contract;
            const scenarioCode = contract.scenarioType.code;

            const baseStage = {
                index: index,
                stageAmount: 0
            };

            if (scenarioCode === SCENARIO_TYPES.CONQUETE) {
                return Object.assign({}, baseStage, {
                    stageDuration: pricesService.getContractTypeValue(),
                    stageRentAmount: order.prices.leaserSubtotal
                });

            }

            if (scenarioCode === SCENARIO_TYPES.RENOUVELLEMENT) {
                const hasFidelityPeriod = contract.nbMonthsFidelity > 0;

                return Object.assign({}, baseStage, {
                    stageDuration: hasFidelityPeriod
                        ? contract.nbMonthsFidelity + pricesService.getContractTypeValue()
                        : pricesService.getContractTypeValue(),
                    stageRentAmount: hasFidelityPeriod
                        ? pricesService.getAmountFinanced()
                        : order.prices.leaserSubtotal
                });

            }

            return null;
        }

        /**
         * Crée les stages sans période de calage
         * @param {Object} order
         * @param {number} startIndex
         * @return {Array}
         */
        function createStagesWithoutCalage(order, startIndex) {
            const contract = order.contract;
            const stages = [];

            if (contract.nbMonthsFidelity > 0) {
                // Stage de fidélité
                stages.push({
                    index: startIndex,
                    stageDuration: contract.nbMonthsFidelity,
                    stageAmount: 0,
                    stageRentAmount: contract.monthlyPaymentFidelity
                });

                // Stage principal
                stages.push({
                    index: startIndex + 1,
                    stageDuration: pricesService.getContractTypeValue(),
                    stageAmount: 0,
                    stageRentAmount: order.prices.leaserSubtotal
                });
            }
            else {
                // Stage unique
                stages.push({
                    index: startIndex,
                    stageDuration: pricesService.getContractTypeValue(),
                    stageAmount: 0,
                    stageRentAmount: order.prices.leaserSubtotal
                });
            }

            return stages;
        }

       /**
        * Construit la partie documents
        * @param  {String} documents
        * @param isPurchase
        * @param orderId
        * @return {[]}
        */
       function buildDocumentsData(documents, isPurchase, orderId) {
           let documentsData = [];
           let ext;
           if (documents.bundle) {
               ext = getExtension(documents.bundle);
               documentsData.push({
                   type: isPurchase ? 'DEAL' : 'BDC',
                   name: 'Liasse_'+orderId+'.'+ext,
                   base64: documents.bundle.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }
           if (documents.cniRecto) {
               ext = getExtension(documents.cniRecto);
               documentsData.push({
                   type: 'CNI',
                   name: 'cni_recto_'+orderId+'.'+ext,
                   base64: documents.cniRecto.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }
           if (documents.cniVerso) {
               ext = getExtension(documents.cniVerso);
               documentsData.push({
                   type: 'CNI',
                   name: 'cni_verso_'+orderId+'.'+ext,
                   base64: documents.cniVerso.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }
           if (documents.iban) {
               ext = getExtension(documents.iban);
               documentsData.push({
                   type: 'IBAN',
                   name: 'rib_'+orderId+'.'+ext,
                   base64: documents.iban.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }
           if (documents.kbis) {
               ext = getExtension(documents.kbis);
               documentsData.push({
                   type: 'KBIS',
                   name: 'kbis_'+orderId+'.'+ext,
                   base64: documents.kbis.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }
           if (documents.bilan) {
               documentsData.push({
                   type: 'OTHER',
                   name: 'bilan_'+orderId+'.pdf',
                   base64: documents.bilan.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }
           if (documents.domiciliation) {
               ext = getExtension(documents.domiciliation);
               documentsData.push({
                   type: 'OTHER',
                   name: 'domiciliation_'+orderId+'.'+ext,
                   base64: documents.domiciliation.split(',')[1],
                   joinedToEnvelope: true,
                   signOrder: 0
               });
           }

           return documentsData;
       }

        function getExtension(base64) {
            let type = base64.split(';')[0];
            return type.split('/')[1];
        }

        self.getType = (base64) => {
            let type = base64.split(';')[0];
            return type.split(':')[1];
        }

        return self;
    }

    ElectronicSignatureService.$inject = [
       'orderService',
       'tillPackService',
       'bdcTabacPresseService',
       'pricesService',
       '$log',
       'filesService',
       '$http'
    ];

    angular
        .module('app.bdc.list.electronicSignatureService', [])
        .factory('electronicSignatureService', ElectronicSignatureService);
});

